import { useTranslation } from 'react-i18next'
import { Form, Input, App } from 'antd';
import { useImperativeHandle, forwardRef } from 'react';
import { useSearchParams } from 'react-router-dom'
import { importWhoDrugC3 } from '@/api/dictionary'
import CustomUpload from './customUpload';

const WhoDrugC3Form = (props, ref: any)=> {
    const { t } = useTranslation()
    const [form] = Form.useForm()
    const [searchParams] = useSearchParams()
    const dictName = searchParams.get('dictName') || ''
    const { message } = App.useApp();

    const onFinish = async ()=>{
        try {
            const values = await form.validateFields()
            const params = new FormData()
            params.append('atcDirFile', values.atcDirFile.file);
            params.append('mpFile', values.mpFile.file);
            params.append('sunFile', values.sunFile.file);
            params.append('pfFile', values.pfFile.file);
            params.append('ccodeFile', values.ccodeFile.file);
            params.append('thgFile', values.thgFile.file);
            params.append('ingFile', values.ingFile.file);
            await importWhoDrugC3(dictName, values.version, params);
            message.success(t('ikg.success', { action: t('dict.addVersion') }))
          } catch (error) {
            throw error
          }
    }

    useImperativeHandle(ref, () => {
        return {
          submit: onFinish,
          resetFields: ()=> {form.resetFields()}
        };
      }, []);

    return <Form
        layout="vertical"
        form={form}
        autoComplete="off"
        initialValues={{
            dictName
        }}
    >
        <Form.Item
            label={t('dict.dictName')} // 字典名称
            name="dictName"
        >
            <Input disabled />
        </Form.Item>
        <Form.Item
        label={t('dict.version')} // 字典名称
        name="version"
        rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.version') }),
            },
        ]}
        >
            <Input placeholder={t('ikg.input', { name: t('dict.version') })} />
        </Form.Item>
        <Form.Item label={t('dict.mpcsv')} name="mpFile" rules={[
                {
                required: true,
                message: t('ikg.input', { name: t('dict.mpcsv') }),
                },
            ]}
        >
            <CustomUpload accept=".csv" fileName='MP.csv' />
        </Form.Item>
        <Form.Item label={t('dict.suncsv')} name="sunFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.suncsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='SUN.csv' />
        </Form.Item>
        <Form.Item label={t('dict.thgcsv')} name="thgFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.thgcsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='ThG.csv' />
        </Form.Item>
        <Form.Item label={t('dict.ccodecsv')} name="ccodeFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.ccodecsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='CCODE.csv' />
        </Form.Item>
        <Form.Item label={t('dict.pfcsv')} name="pfFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.pfcsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='PF.csv' />
        </Form.Item>
        <Form.Item label={t('dict.atccsv')} name="atcDirFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.atccsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='ATC.csv' />
        </Form.Item>
        <Form.Item label={t('dict.INGcsv')} name="ingFile" rules={[
            {
            required: true,
            message: t('ikg.input', { name: t('dict.INGcsv') }),
            },
        ]}>
            <CustomUpload accept=".csv" fileName='ING.csv' />
        </Form.Item>
    </Form>
}

export default forwardRef(WhoDrugC3Form)
